function WoocommerceButton(){

    this.build();

}

WoocommerceButton.prototype.build = function(){

    let that  =this;
    that.addWrapper();

    $( document ).ajaxComplete(function() {
        that.addWrapper();
    });

    const add_to_cart = document.querySelectorAll(".add-to-cart");
    add_to_cart.forEach(el => {
        el.addEventListener('click', e => {
            e.preventDefault();
            el.classList.add('loading');

            var data = {
                action: 'mc_woocommerce_ajax_add_to_cart',
                product_id: el.dataset.productId,
                product_sku: '',
                quantity: 1,
                variation_id: '',
            };

            $.ajax({
                type: 'post',
                url: wc_add_to_cart_params.ajax_url,
                data: data,
                beforeSend: function (response) {
                    el.classList.remove('added');
                    el.classList.add('loading');
                },
                complete: function (response) {
                    el.classList.add('added');
                    el.classList.remove('loading');
                    setTimeout(function(){
                        el.classList.remove('added');
                    },1000)
                },
                success: function (response) {
                    if (response.error && response.product_url) {
                        window.location = response.product_url;
                        return;
                    } else {
                        $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash]);
                    }
                },
            });

        });

        return false;
    });

    let pins = document.querySelectorAll('.pinner');

    pins.forEach( e => {
        ScrollTrigger.create({
            trigger: e,
            pin: true,
            start: "top top",
            end: document.body.clientHeight
        });
    });

};

WoocommerceButton.prototype.addWrapper = function(){

    let svg_submit = "<span class='svg'>" +
        "<img src='"+mcubeArgs.themeLink+"/svg/next.svg'><img src='"+mcubeArgs.themeLink+"/svg/hourglass.svg'>" +
        "<span>" +
        "<img src='"+mcubeArgs.themeLink+"/svg/ellipse.svg'></span>" +
        "</span>";

    $('.button:not(.btn):not(.woocommerce-button)').each(function(){

        if( $(this).closest('.button-submit-wrapper').length == 0 ) {
            $(this).wrap('<div class="button-submit-wrapper"></div>');
            $(this).closest('.button-submit-wrapper').append(svg_submit);
        }

    });

};